const {
  required
} = require('vuelidate/lib/validators')

export default {
  titulo: { required },
  id_artista: { required },
}